import request from '@/api/base'

// 公寓入住企业统计报表
const rentalCompanyStatistical = (params) => {
  // params.mockApi = true
  return request.post('/portal/apartment/rental/rentalCompanyStatisticalInfoVO', params)
}
// 公寓入住 统计报表
const rentalStatistical = (params) => {
  return request.post('/portal/apartment/rental/rentalStatisticalInfoVO', params)
}

// 租赁情况统计表
const getBuildRentalInfoRequestV = (params) => {
  return request.post('/portal/open/statistical/getBuildRentalInfoRequestVO', params)
}

// 获取房产信息统计表
const getRoomStatisticalInfoV = (params) => {
  return request.post('/open/statistical/getRoomStatisticalInfoVO', params)
}

// 运用统计 pv uv(实时统计)
const realTime = (params) => {
  return request.post('/ipark-bigdata/IparkStatisticsOperation/realTime', params)
}
// 运用统计 pv uv(区间统计)
const realTimeList = (params) => {
  return request.post('/ipark-bigdata/IparkStatisticsOperation/list', params)
}

// 运用统计 今日pv 数据详情(区间统计)
const currentPvUv = (params) => {
  return request.post('/ipark-bigdata/rest/appPage/currentPvUv', params)
}

// 运用统计 过段时间累积 pv 数据详情(区间统计)
const historyCountPvUv = (params) => {
  return request.post('/ipark-bigdata/rest/appPage/historyCountPvUv', params)
}

export default {
  rentalCompanyStatistical,
  rentalStatistical,
  getBuildRentalInfoRequestV,
  getRoomStatisticalInfoV,
  realTime,
  realTimeList,
  currentPvUv,
  historyCountPvUv
}



// WEBPACK FOOTER //
// ./src/area-contract/api/datastatiscssService.js